<template>
  <v-card
    class="ma-3"
    v-if="AuthenticationMixin_LoggedIn && AuthenticationMixin_HasRights(['gebruiker','admin'])">
    <v-row class="justify-space-between">
      <v-col cols="12" md="6" lg="4">
        <v-text-field
          class="pa-2"
          clearable
          v-model="search"
          v-on:input="callDebounceSearch"
          append-icon="mdi-magnify"
          label="Zoeken"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="12" lg="8">
        <v-btn
          class="ma-5 float-right d-none d-md-block"
          color="primary"
          @click="OpenExportDialog()"
        >
          <v-icon>mdi-export</v-icon>
          {{ exporteerVergelijkingspuntTekst }}
        </v-btn>
        <v-btn
          class="ma-5 float-right d-none d-md-block"
          color="primary"
          @click="openVergelijkingspunt()"
        >
          <v-icon>mdi-plus</v-icon>
          Nieuw vergelijkingspunt
        </v-btn>
      <v-btn
        class="ma-5 float-right d-md-none"
        color="primary"
        @click="openVergelijkingspunt()"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      </v-col>
      <v-col cols="12" md="12" lg="12">
        <v-select
          class="pa-2"
          v-model="selectedColumns"
          :items="headers"
          item-text="text"
          item-value="value"
          label="Selecteer zichtbare kolommen"
          multiple
          chips
          deletable-chips
        />
      </v-col>
    </v-row>
    <v-data-table
      v-model="vergelijkingspuntSelectie"
      dense
      :headers="filteredHeaders"
      :items="items"
      item-key="idVergelijkingspunt"
      :search="search"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :footer-props="{
        itemsPerPageText: 'Vergelijkingspunten per pagina',
        'items-per-page-options': [25, 25, 50, 100]
      }"
      class="elevation-1"
      @click:row="openVergelijkingspunt"
      show-select
    >
    <template v-slot:[`item.perceelBreedte`]="{ item }">
      <template v-if="item.perceelBreedte != null">
      {{ FormatMixin_FormatDecimal(item.perceelBreedte, 0) }} m
      </template>
      <template v-else>
        /
      </template>
    </template>
    <template v-slot:[`item.perceelOppervlakte`]="{ item }">
      <template v-if="item.perceelOppervlakte != null">
      {{ FormatMixin_FormatDecimal(item.perceelOppervlakte, 0) }} m²
      </template>
      <template v-else>
        /
      </template>
    </template>
    <template v-slot:[`item.bewoonbareOppervlakte`]="{ item }">
      <template v-if="item.bewoonbareOppervlakte != null">
      {{ FormatMixin_FormatDecimal(item.bewoonbareOppervlakte, 0) }} m²
      </template>
      <template v-else>
        /
      </template>
    </template>
    <template v-slot:[`item.bouwjaar`]="{ item }">
      <template v-if="item.bouwjaar != null">
      {{ item.bouwjaar }}
      </template>
      <template v-else>
        /
      </template>
    </template>
    <template v-slot:[`item.verkoopType`]="{ item }">
      <template v-if="item.verkoopType != null">
      {{ item.verkoopType }}
      </template>
      <template v-else>
        /
      </template>
    </template>
    <template v-slot:[`item.renovatiejaar`]="{ item }">
      <template v-if="item.renovatiejaar != null">
      {{ item.renovatiejaar }}
      </template>
      <template v-else>
        /
      </template>
    </template>
    <template v-slot:[`item.ki`]="{ item }">
        <template v-if="item.ki != null">
        € {{ FormatMixin_FormatDecimal(item.ki, 2) }}
        </template>
        <template v-else>
          /
        </template>
      </template>
    <template v-slot:[`item.datumVerkoop`]="{ item }">
        <template v-if="item.datumVerkoop != null">
        {{ FormatMixin_FormatDateTime(item.datumVerkoop, formatMixin.date.database, formatMixin.date.monthnameYear, 'nl-BE') }}
        </template>
        <template v-else>
          /
        </template>
      </template>
    <template v-slot:[`item.verkoopprijs`]="{ item }">
      <template v-if="item.verkoopprijs != null">
      € {{ FormatMixin_FormatDecimal(item.verkoopprijs, 0) }}
      </template>
      <template v-else>
        /
      </template>
    </template>
    <template v-slot:[`item.adres`]="{ item }">
        {{ item.straat }} {{ item.huisnummer }}
      </template>
    <template v-slot:[`item.idPostcode`]="{ item }">
        {{ GetGemeenteByIdPostcode(item.idPostcode) }}
      </template>
    <template v-slot:[`item.idCodeBebouwing`]="{ item }">
      <template v-if="item.idCodeBebouwing != null">
        {{ GetBebouwingByIdCodeBebouwing(item.idCodeBebouwing) }}
      </template>
      <template v-else>
        /
      </template>
    </template>
    <template v-slot:[`item.vetustiteit`]="{ item }">
      <template v-if="item.vetustiteit != null">
        {{ FormatMixin_FormatDecimal(item.vetustiteit, 2) }} %
      </template>
      <template v-else>
        /
      </template>
    </template>
    <template v-slot:[`item.bijgebouwenOppervlakte`]="{ item }">
      <template v-if="item.bijgebouwenOppervlakte != null">
        {{ FormatMixin_FormatDecimal(item.bijgebouwenOppervlakte, 0) }} m²
      </template>
      <template v-else>
        /
      </template>
    </template>
    <template v-slot:[`item.heeftGarage`]="{ item }">
      <template v-if="item.heeftGarage != null">
        {{ GetHeeftGarageTekst(item.heeftGarage) }}
      </template>
      <template v-else>
        /
      </template>
    </template>
    <template v-slot:[`item.opmerking`]="{ item }">
      <template v-if="item.opmerking != null">
        {{ item.opmerking }}
      </template>
      <template v-else>
        /
      </template>
    </template>
      <template v-slot:[`item.acties`]="{ item }">
        <v-btn
        icon
        class="deleteItem"
        @click.stop="deleteItem (item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
    </template>
    </v-data-table>

    <!-- EXPORT DIALOG  -->
   <v-dialog
    v-model="openExportDialog"
    :persistent="loadingExport"
    max-width="500">
     <v-card>
       <v-card-title class="text-h5">
         {{ exporteerVergelijkingspuntTekst }}
       </v-card-title>
        <v-card-text>
       <v-select
          v-model="selectedFormat"
          :items="exportFormats"
          label="Exporteren als:"
        />
        <v-text-field
          v-model="exportName"
          label="Export naam (optioneel)"
          hint="Laat leeg voor automatische naamgeving"
          persistent-hint
        />
        </v-card-text>
       <v-card-actions>
         <v-btn
           color="primary"
           text
           :disabled="loadingExport"
           @click="OpenExportDialog">
           Annuleren
         </v-btn>
         <v-spacer></v-spacer>
         <v-btn
          :disabled="selectedFormat === null"
          :loading="loadingExport"
           color="primary darken-1"
           @click="VoegExportToeAanWachtrij()">
           Exporteer
         </v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>

    <!-- DELETE DIALOG -->
    <v-dialog
        v-model="deletedialog"
        max-width="500">
        <v-card>
          <v-card-title class="text-h5">
            Vergelijkingspunt verwijderen
          </v-card-title>
          <v-card-text v-if="selectedItem">
            Ben je zeker dat je '<strong>{{ selectedItem.pand }}</strong>' wilt verwijderen?
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary darken-1"
              @click="deletedialog = false">
              Nee
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              text
              @click="DeleteVergelijkingspunt">
              Ja, verwijderen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-form
        v-model="valid"
        ref="form"
        lazy-validation>
        <v-dialog
          v-model="editdialog"
          max-width="750">
          <v-card>
            <v-card-title class="text-h5 primary--text">
              {{ editdialogTitle }}
            </v-card-title>
            <v-card-text v-if="selectedItem">
              <v-row class="py-0">
                <v-col cols="8" sm="10">
                <option-list
                  v-model="selectedItem.pand"
                  :list="aarden"
                  label="Pand"
                  :rules="[validationMixin.rules.required]"
                />
                </v-col>
                <v-col cols="4" sm="2">
                  <control-select
                    :items="bebouwingen"
                    label="Bebouwing"
                    v-model="selectedItem.idCodeBebouwing"
                    :itemValue="'idCode'"
                    :itemText="'langeBeschrijving'"
                  />
                </v-col>
              </v-row>
              <v-row class="py-0">
                <v-col cols="8" sm="10">
                  <v-text-field
                    label="Straat"
                    v-model="selectedItem.straat"
                    :rules="[v => !!v || 'Straat is verplicht']"
                  />
                </v-col>
                <v-col cols="4" sm="2">
                  <v-text-field
                    label="Huisnr."
                    v-model="selectedItem.huisnummer"
                    :rules="[v => !!v || 'Huisnr. is verplicht']"
                  />
                </v-col>
                <v-col cols="12">
                  <contol-postcode
                    label="Gemeente"
                    v-model="selectedItem.idPostcode"
                    required
                    requiredText="Gemeente is verplicht"
                  />
                </v-col>
              </v-row>
              <v-row class="py-0">
                <v-col class="py-0" cols="12" sm="4">
                  <v-text-field
                    v-model="selectedItem.kadastraleAfdeling"
                    label="Kadastrale afdeling"
                    :rules="[v => !!v || 'Kadastrale afdeling is verplicht']"
                  />
                </v-col>
                <v-col class="py-0" cols="12" sm="4">
                  <v-text-field
                    v-model="selectedItem.kadastraleSectie"
                    label="Kadastrale sectie"
                    :rules="[v => !!v || 'Kadastrale sectie is verplicht']"
                  />
                </v-col>
                <v-col class="py-0" cols="12" sm="4">
                  <v-text-field
                    v-model="selectedItem.kadastraleNummers"
                    label="Kadastrale nrs."
                    required
                    :rules="[v => !!v || 'Kadastrale nrs. is verplicht']"
                  />
                </v-col>
              </v-row>
              <v-row class="py-0">
                <v-col class="py-0" cols="12" sm="4">
                  <control-number
                    v-model="selectedItem.perceelBreedte"
                    label="Perceel breedte"
                    suffix="m"
                    required
                    requiredText="Perceel breedte is verplicht"
                  />
                </v-col>
                <v-col class="py-0" cols="12" sm="4">
                    <control-number
                      v-model="selectedItem.perceelOppervlakte"
                      label="Perceel oppervlakte"
                      suffix="m²"
                      required
                      requiredText="Perceel oppervlakte is verplicht"/>
                </v-col>
                <v-col class="py-0" cols="12" sm="4">
                    <control-number
                      v-model="selectedItem.bewoonbareOppervlakte"
                      label="Bewoonbare oppervlakte"
                      suffix="m²"
                      required
                      requiredText="Bewoonbare oppervlakte is verplicht"/>
                </v-col>
              </v-row>
              <v-row class="py-0">
                <v-col class="py-0" cols="6" sm="4">
                    <control-number
                      label="KI"
                      v-model="selectedItem.ki"
                      prefix="€"
                      />
                </v-col>
                <v-col class="py-0" cols="6" sm="4">
                  <control-number
                    v-model="selectedItem.epcScore"
                    label="EPC-score (kWh/m²/jaar)"
                    :decimals="0"
                  />
                </v-col>
                <v-col class="py-0" cols="6" sm="4">
                  <control-number
                    v-model="selectedItem.bijgebouwenOppervlakte"
                    label="Bijgebouw oppervlakte"
                    suffix="m²"
                    :decimals="0"
                  />
                </v-col>
              </v-row>
              <v-row class="py-0" justify="start">
              <v-col class="py-0" cols="6" sm="4">
                <v-checkbox
                  v-model="selectedItem.heeftGarage"
                  label="Garage"/>
              </v-col>
              <v-col class="py-0" cols="6" sm="4" v-show="selectedItem.heeftGarage">
                <control-number
                  v-model="selectedItem.garageOppervlakte"
                  suffix="m²"
                  label="Garage oppervlakte"
                />
              </v-col>
              <v-col class="py-0" cols="6" sm="4">
                <control-number
                  v-model="selectedItem.vetustiteit"
                  suffix="%"
                  label="Vetustiteit"
                  />
              </v-col>
            </v-row>
              <v-row class="py-0">
                <v-col class="py-0" cols="6" sm="3">
                  <control-number
                    v-model="selectedItem.bouwjaar"
                    label="Bouwjaar"
                    :withDotSeparator="false"
                  />
                </v-col>
                <v-col class="py-0" cols="6" sm="3">
                  <control-number
                    v-model="selectedItem.renovatiejaar"
                    label="Renovatiejaar"
                    :withDotSeparator="false"
                  />
                </v-col>
                <v-col class="py-0" cols="6" sm="3">
                  <control-select
                    v-model="selectedItem.maandVerkoop"
                    label="Maand verkoop"
                    :items="months"
                    itemText="text"
                    itemValue="value"
                    required
                    requiredText="Maand verkoop is verplicht"
                  />
                </v-col>
                <v-col class="py-0" cols="6" sm="3">
                    <control-number
                      label="Jaar verkoop"
                      v-model="selectedItem.jaarVerkoop"
                      :withDotSeparator="false"
                      required
                      requiredText="Jaar verkoop is verplicht"/>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <control-number
                    label="Verkoopprijs"
                    v-model="selectedItem.verkoopprijs"
                    prefix="€"
                    required
                    requiredText="Verkoopprijs is verplicht"/>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <control-select
                    :items="verkoopTypeList"
                    label="Type verkoop"
                    v-model="selectedItem.idCodeVerkoopType"
                    :itemValue="'idCode'"
                    :itemText="'langeBeschrijving'"
                  />
                </v-col>
                <v-col class="py-0" cols="12" sm="12">
                  <v-textarea
                    v-model="selectedItem.opmerking"
                    label="Opmerking"
                    auto-grow
                    rows="3"
                  />
                </v-col>
              </v-row>
              <label for="bijlage">Bijlage (afbeeldingen)</label>
              <control-file-input-drag-and-drop-vue id="bijlage" single v-model="bijlage" @download="Download($event)" :accept="['.png', '.jpg', '.jpeg', '.gif']"/>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary darken-1"
                text
                @click="editdialog = false">
                Terug
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                v-if="!isEditVergelijkingspuntDialog"
                color="primary darken-1"
                @click="CreateVergelijkingspunt">
                Aanmaken
              </v-btn>
              <v-btn
                v-if="isEditVergelijkingspuntDialog"
                color="primary darken-1"
                @click="UpdateVergelijkingspunt">
                Opslaan
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
  </v-card>
  <v-card class="ma-3" v-else>
    <h2 class="primary--text pa-3">Log in om de schattingenlijst te kunnen bekijken.</h2>
  </v-card>
</template>

<script>
import _ from 'lodash'
import sum from 'lodash/sum'
import errorMixin from '../mixins/errorMixin'
import ControlFileInputDragAndDropVue from './ControlFileInputDragAndDrop.vue'
import vergelijkingspuntService from '../services/vergelijkingspuntService'
import authenticationMixin from '../mixins/authenticationMixin'
import formatMixin from '../mixins/formatMixin'
import validationMixin from '../mixins/validationMixin'
import ContolPostcode from '../components/ControlPostcode.vue'
import ControlNumber from './ControlNumber.vue'
import ControlSelect from './ControlSelect.vue'
import postService from '../services/postService'
import codeService from '../services/codeService'
import guidService from '../services/guidService'
import commonMixin from '../mixins/commonMixin'
import OptionList from '../components/OptionList'
import blobMixin from '../mixins/blobMixin'
import moment from 'moment'
import templateService from '../services/templateService'
import blobService from '../services/blobService'
import VergelijkingspuntExportUtil from '../utils/vergelijkingspuntExportUtil'

export default {
  components: {
    ControlFileInputDragAndDropVue,
    ContolPostcode,
    ControlNumber,
    ControlSelect,
    OptionList
  },
  mixins: [
    errorMixin,
    authenticationMixin,
    blobMixin,
    formatMixin,
    validationMixin,
    commonMixin
  ],
  name: 'Vergelijkingspunten',
  data () {
    return {
      selectedFormat: null,
      exportFormats: ['Word (.docx)', 'Excel (.xlsx)'],
      openExportDialog: false,
      exportName: null,
      vergelijkingspuntSelectie: [],
      bebouwingen: [],
      aarden: [
        'Woning',
        'Appartement',
        'Bouwgrond',
        'Landbouwgrond',
        'Handelspand',
        'Kantoor',
        'Opbrengsteigendom',
        'Bosgrond',
        'Natuurgebied',
        'KMO',
        'Industrie',
        'Garage',
        'Boerderij',
        'Projectgrond'
      ],
      rollen: [],
      valid: true,
      showPassword: false,
      showPassword2: false,
      selectedItem: null,
      formattedSelectedItem: null,
      deletedialog: false,
      editdialog: false,
      isEditVergelijkingspuntDialog: false,
      editdialogTitle: null,
      editDialogWachtwoordWijzigen: false,
      totalItems: 0,
      items: [],
      postcodes: null,
      search: null,
      loading: true,
      options: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 25
      },
      months: [
        { value: '1', text: 'januari' },
        { value: '2', text: 'februari' },
        { value: '3', text: 'maart' },
        { value: '4', text: 'april' },
        { value: '5', text: 'mei' },
        { value: '6', text: 'juni' },
        { value: '7', text: 'juli' },
        { value: '8', text: 'augustus' },
        { value: '9', text: 'september' },
        { value: '10', text: 'oktober' },
        { value: '11', text: 'november' },
        { value: '12', text: 'december' }
      ],
      headers: [
        {
          text: 'Pand',
          align: 'start',
          value: 'pand',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Bebouwing',
          align: 'start',
          value: 'idCodeBebouwing',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Adres',
          align: 'start',
          value: 'adres',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Gemeente',
          align: 'start',
          value: 'idPostcode',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Bouwjaar',
          align: 'end',
          value: 'bouwjaar',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Renovatiejaar',
          align: 'end',
          value: 'renovatiejaar',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Vetustiteit',
          align: 'start',
          value: 'vetustiteit',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Perceel breedte',
          align: 'end',
          value: 'perceelBreedte',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Perceel opp.',
          align: 'end',
          value: 'perceelOppervlakte',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Bewoonbare opp.',
          align: 'end',
          value: 'bewoonbareOppervlakte',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Oppervlakte bijgebouwen',
          align: 'end',
          value: 'bijgebouwenOppervlakte',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Garage',
          align: 'start',
          value: 'heeftGarage',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'KI',
          align: 'end',
          value: 'ki',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Datum verkoop',
          align: 'end',
          value: 'datumVerkoop',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Verkoopprijs',
          align: 'end',
          value: 'verkoopprijs',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Verkooptype',
          align: 'end',
          value: 'verkoopType',
          width: 'auto',
          class: 'text-no-wrap'
        },
        {
          text: 'Opmerkingen',
          align: 'start',
          value: 'opmerking',
          width: 'auto',
          class: 'text-no-wrap'
        }
      ],
      bijlage: null,
      vergelijkingsPuntType: '8ab75f12-6f71-4ed2-92b6-03732d5e696b',
      verkoopTypeList: [],
      templates: [],
      loadingExport: false,
      selectedColumns: [
        'pand',
        'adres',
        'idPostcode',
        'bouwjaar',
        'perceelOppervlakte',
        'bewoonbareOppervlakte',
        'verkoopprijs',
        'acties'
      ]
    }
  },
  watch: {
    options: {
      handler () {
        this.getDataFromApi()
      },
      deep: true
    }
  },
  computed: {
    filteredHeaders () {
      return this.headers.filter(header => this.selectedColumns.includes(header.value) || header.value === 'acties')
    },
    exporteerVergelijkingspuntTekst () {
      if (this.vergelijkingspuntSelectie.length > 1) {
        return `Exporteer ${this.vergelijkingspuntSelectie.length} vergelijkingspunten`
      } else if (this.vergelijkingspuntSelectie.length === 1) {
        return 'Exporteer 1 vergelijkingspunt'
      } else {
        return `Exporteer alle (${this.totalItems}) vergelijkingspunten`
      }
    }
  },

  async mounted () {
    await vergelijkingspuntService.Init(this)
    await postService.Init(this)
    await guidService.Init(this)
    await codeService.Init(this)
    templateService.Init(this)
    blobService.Init(this)
    this.GetPosten()
    this.GetVerkoopTypeList()
    this.GetTemplates()
    this.getDataFromApi()
  },
  methods: {
    OpenExportDialog () {
      this.openExportDialog = !this.openExportDialog
      this.selectedFormat = null
      this.exportName = null
    },
    // TOEVOEGEN AAN EXPORT WACHTRIJ
    async VoegExportToeAanWachtrij () {
      this.loadingExport = true
      const itemsToExport = this.vergelijkingspuntSelectie.length > 0 ? this.vergelijkingspuntSelectie : this.items

      if (this.selectedFormat === 'Word (.docx)') {
        var format = 'word'
        const vergelijkingspuntenTemplate = this.templates.find(t => t.naam === 'Vergelijkingspunten Template')

        if (!vergelijkingspuntenTemplate) {
          this.ErrorMixin_HandleError({ message: 'Template "Vergelijkingspunten Template" niet gevonden' })
          return
        }
        try {
          const idBlob = vergelijkingspuntenTemplate.idBlob
          if (idBlob) {
            try {
              const template = {
                IdBlob: idBlob,
                ItemIds: itemsToExport.map(item => item.idVergelijkingspunt),
                ExportName: this.exportName
              }

              // Call AddExportToQueue
              const response = await templateService.AddExportToQueue(template, format, 'vergelijkingspunten')
              if (response && response.data) {
                // Show success message from API response
                const message = 'Export toegevoegd aan wachtrij'
                this.CommonMixin_Snackbar(message, 'success')

                // sluit dialog wanneer succesvol toegevoegd aan wachtrij
                this.openExportDialog = false
                this.selectedFormat = null
              } else {
                this.ErrorMixin_HandleError({ message: 'Kon het bestand niet toevoegen aan wachtrij. Probeer het opnieuw.' })
              }
            } catch (error) {
              this.ErrorMixin_HandleError(error)
            } finally {
              this.loadingExport = false
            }
          } else {
            this.ErrorMixin_HandleError({ message: 'Template blob niet gevonden' })
            this.loadingExport = false
          }
        } catch (error) {
          this.ErrorMixin_HandleError(error)
        } finally {
          this.loadingExport = false
        }
      } else {
      // Export naar excel
        format = 'excel'
        try {
          const template = {
            ItemIds: itemsToExport.map(item => item.idVergelijkingspunt),
            ExportName: this.exportName

          }
          // Call AddExportToQueue
          const response = await templateService.AddExportToQueue(template, format, 'vergelijkingspunten')
          if (response && response.data) {
            // Show success message from API response
            const message = 'Export toegevoegd aan wachtrij'
            this.CommonMixin_Snackbar(message, 'success')

            // sluit dialog wanneer succesvol toegevoegd aan wachtrij
            this.openExportDialog = false
            this.selectedFormat = null
          } else {
            this.ErrorMixin_HandleError({ message: 'Kon het bestand niet toevoegen aan wachtrij. Probeer het opnieuw.' })
          }
        } catch (error) {
          this.ErrorMixin_HandleError(error)
        } finally {
          this.loadingExport = false
        }
      }
      this.vergelijkingspuntSelectie = []
    },
    async ExportVergelijkingspunten () {
      const itemsToExport = this.vergelijkingspuntSelectie.length > 0 ? this.vergelijkingspuntSelectie : this.items

      if (this.selectedFormat === 'Word (.docx)') {
        const vergelijkingspuntenTemplate = this.templates.find(t => t.naam === 'Vergelijkingspunten Template')

        if (!vergelijkingspuntenTemplate) {
          this.ErrorMixin_HandleError({ message: 'Template "Vergelijkingspunten Template" niet gevonden' })
          return
        }

        this.loadingExport = true

        try {
          const resp = await blobService.Download(vergelijkingspuntenTemplate.idBlob)
          if (resp && resp.data) {
            const reader = new FileReader()
            const blob = resp.data
            reader.onload = async (e) => {
              try {
                const template = {
                  Blob: {
                    BlobDataString: e.target.result,
                    BlobDataPrefix: `${e.target.result.substr(0, e.target.result.indexOf('base64,') + 7)}`
                  },
                  VergelijkingspuntenIds: itemsToExport.map(item => item.idVergelijkingspunt)
                }

                // Call GetVergelijkingspuntenDocument
                const response = await templateService.GetVergelijkingspuntenDocument(template)
                if (response && response.data) {
                  // Download document
                  const link = document.createElement('a')
                  link.href = response.data
                  link.download = `Vergelijkingspunten_${new Date().toISOString().split('T')[0]}.docx`
                  link.click()

                  // sluit dialog wanneer succesvol geëxporteerd
                  this.openExportDialog = false
                  this.selectedFormat = null
                } else {
                  this.ErrorMixin_HandleError({ message: 'Geen document ontvangen van server' })
                }
              } catch (error) {
                this.ErrorMixin_HandleError(error)
              } finally {
                this.loadingExport = false
              }
            }
            reader.readAsDataURL(blob)
          } else {
            this.ErrorMixin_HandleError({ message: 'Template blob niet gevonden' })
            this.loadingExport = false
          }
        } catch (error) {
          this.ErrorMixin_HandleError(error)
          this.loadingExport = false
        }
      } else if (this.selectedFormat === 'Excel (.xlsx)') {
        this.loadingExport = true

        try {
          // Use the Excel export utility
          const exportUtil = new VergelijkingspuntExportUtil(this)
          exportUtil.downloadExcel(itemsToExport)

          // Sluit dialog wanneer succesvol geëxporteerd
          this.openExportDialog = false
          this.selectedFormat = null
        } catch (error) {
          this.ErrorMixin_HandleError(error)
        } finally {
          this.loadingExport = false
        }
      }
    },
    async GetTemplates () {
      const response = await templateService.GetAll(true)
      if (response && response.data) {
        this.templates = response.data
      }
    },
    Download (blob) {
      const blobFormatted = this.CommonMixin_Clone(blob)
      blobFormatted.bestandsnaam = blob.name
      this.BlobMixin_Download(blobFormatted)
    },
    async GetVerkoopTypeList () {
      const response = await codeService.GetVerkoopTypeList()
      if (response && response.data) {
        const data = response.data
        this.verkoopTypeList = data
      }
    },
    SetBijgebouwOppervlakte (vergelijkingspunt) {
      if (vergelijkingspunt.bijgebouwen != null) {
        return sum(vergelijkingspunt.bijgebouwOppervlakte.map(x => x.oppervlakteBijgebouw))
      } else if (vergelijkingspunt.bijgebouwenOppervlakte != null) {
        return vergelijkingspunt.bijgebouwenOppervlakte
      } else {
        return null
      }
    },
    async GetVergelijkingspuntenPaged (sortBy, sortType, search, page, pageSize) {
      const response = await vergelijkingspuntService.GetVergelijkingspuntenPaged(sortBy, sortType, search, page, pageSize)
      if (response && response.data) {
        const data = response.data
        this.items = data.items
        this.totalItems = data.totalItems
      }
    },
    async getDataFromApi () {
      this.loading = true
      await this.GetVergelijkingspuntenPaged(this.options.sortBy[0], this.options.sortDesc[0] ? 'desc' : 'asc', this.search, this.options.page, this.options.itemsPerPage).then(data => {
        this.loading = false
      })

      await this.GetBebouwingen()
    },
    getStatusColor (status) {
      switch (status) {
        case 'Afgehandeld':
          return '#2e7a2e'
        case 'Aanpassen':
          return '#356191'
        case 'Concept':
          return 'darkgrey'
      }
    },
    callDebounceSearch: _.debounce(function () {
      this.debounceSearch()
    }, 500),
    debounceSearch () {
      this.getDataFromApi()
    },
    GetGemeenteByIdPostcode (idPostcode) {
      if (this.postcodes != null) {
        var gemeente = this.postcodes.find(x => x.idPostcode === idPostcode)
        if (gemeente && gemeente.tekst) {
          return gemeente.tekst
        }
      }
    },
    async openVergelijkingspunt (vergelijkingspunt) {
      this.editDialogWachtwoordWijzigen = false
      this.showPassword = false
      this.showPassword2 = false
      this.$refs.form.resetValidation()
      if (vergelijkingspunt) {
        this.editdialogTitle = 'Wijzig vergelijkingspunt'
        this.isEditVergelijkingspuntDialog = true
        this.selectedItem = {
          idVergelijkingspunt: vergelijkingspunt.idVergelijkingspunt,
          pand: vergelijkingspunt.pand,
          straat: vergelijkingspunt.straat,
          huisnummer: vergelijkingspunt.huisnummer,
          idPostcode: vergelijkingspunt.idPostcode,
          bouwjaar: vergelijkingspunt.bouwjaar,
          perceelOppervlakte: vergelijkingspunt.perceelOppervlakte,
          bewoonbareOppervlakte: vergelijkingspunt.bewoonbareOppervlakte,
          perceelBreedte: vergelijkingspunt.perceelBreedte,
          ki: vergelijkingspunt.ki,
          jaarVerkoop: vergelijkingspunt.datumVerkoop ? new Date(vergelijkingspunt.datumVerkoop).getFullYear() : null,
          maandVerkoop: vergelijkingspunt.datumVerkoop ? (new Date(vergelijkingspunt.datumVerkoop).getMonth() + 1).toString() : null,
          datumVerkoop: vergelijkingspunt.datumVerkoop,
          verkoopprijs: vergelijkingspunt.verkoopprijs,
          idCodeVerkoopType: vergelijkingspunt.idCodeVerkoopType,
          verkoopType: vergelijkingspunt.verkoopType,
          epcScore: vergelijkingspunt.epcScore,
          renovatiejaar: vergelijkingspunt.renovatiejaar,
          kadastraleAfdeling: vergelijkingspunt.kadastraleAfdeling,
          kadastraleSectie: vergelijkingspunt.kadastraleSectie,
          kadastraleNummers: vergelijkingspunt.kadastraleNummers,
          opmerking: vergelijkingspunt.opmerking,
          heeftGarage: vergelijkingspunt.heeftGarage,
          garageOppervlakte: vergelijkingspunt.garageOppervlakte,
          vetustiteit: vergelijkingspunt.vetustiteit,
          bijgebouwenOppervlakte: this.SetBijgebouwOppervlakte(vergelijkingspunt),
          idCodeBebouwing: vergelijkingspunt.idCodeBebouwing ? vergelijkingspunt.idCodeBebouwing : null
        }
        var blobs = (await this.BlobMixin_GetFiles(this.selectedItem.idVergelijkingspunt, this.vergelijkingsPuntType))
        this.bijlage = []
        if (blobs.length > 0) {
          blobs.forEach(blob => {
            this.bijlage.push(blob)
          })
        }
      } else {
        this.editdialogTitle = 'Nieuw vergelijkingspunt'
        this.isEditVergelijkingspuntDialog = false
        const response = await guidService.New()
        let newGuid = null
        if (response && response.data) {
          newGuid = response.data
        }
        this.selectedItem = {
          idVergelijkingspunt: newGuid,
          pand: null,
          straat: null,
          huisnummer: null,
          idPostcode: null,
          bouwjaar: null,
          oppervlakte: null,
          ki: null,
          datumVerkoop: null,
          maandVerkoop: null,
          jaarVerkoop: null,
          verkoopprijs: null,
          kadastraleAfdeling: null,
          kadastraleSectie: null,
          kadastraleNummers: null,
          heeftGarage: null,
          garageOppervlakte: null,
          vetustiteit: null,
          bijgebouwenOppervlakte: null,
          idCodeBebouwing: null
        }
        this.bijlage = []
      }
      this.editdialog = true
    },
    async GetPosten () {
      const response = await postService.GetPosten()
      if (response && response.data) {
        const data = response.data
        this.postcodes = data
      }
    },
    async GetBebouwingen () {
      const response = await codeService.GetBebouwingen()
      if (response && response.data) {
        const data = response.data
        this.bebouwingen = data
      }
    },
    GetBebouwingByIdCodeBebouwing (idCodeBebouwing) {
      if (this.bebouwingen != null) {
        var bebouwing = this.bebouwingen.find(x => x.idCode === idCodeBebouwing)
        if (bebouwing && bebouwing.langeBeschrijving) {
          return bebouwing.langeBeschrijving
        }
      }
    },
    GetHeeftGarageTekst (heeftGarage) {
      if (heeftGarage) {
        return 'Ja'
      } else {
        return 'Nee'
      }
    },
    deleteItem (item) {
      this.selectedItem = item
      this.deletedialog = true
    },
    async CreateVergelijkingspunt () {
      if (this.$refs.form.validate()) {
        this.FormatSelectedItem()
        if (this.bijlage && this.bijlage.length > 0) {
          await this.BlobMixin_SaveFiles(this.bijlage, this.selectedItem.idVergelijkingspunt, this.vergelijkingsPuntType)
          var blobs = await this.BlobMixin_GetFiles(this.selectedItem.idVergelijkingspunt, this.vergelijkingsPuntType)
          this.CommonMixin_SuccessOrFailMessage((blobs && blobs.length === this.bijlage.length) || !this.bijlage, null, 'Bijlage is niet correct opgeslagen.')
        }

        const response = await vergelijkingspuntService.Create(this.formattedSelectedItem)
        if (response && response.data !== null) {
          this.editdialog = false
          this.getDataFromApi()
        }
      }
    },
    async UpdateVergelijkingspunt () {
      if (this.$refs.form.validate()) {
        this.FormatSelectedItem()
        if (this.bijlage && this.bijlage.length > 0) {
          await this.BlobMixin_SaveFiles(this.bijlage, this.selectedItem.idVergelijkingspunt, this.vergelijkingsPuntType)
          var blobs = await this.BlobMixin_GetFiles(this.selectedItem.idVergelijkingspunt, this.vergelijkingsPuntType)
          this.CommonMixin_SuccessOrFailMessage((blobs && blobs.length === this.bijlage.length) || !this.bijlage, null, 'Bijlage is niet correct opgeslagen.')
        }

        const response = await vergelijkingspuntService.Update(this.formattedSelectedItem)
        if (response && response.data !== null) {
          this.editdialog = false
          this.getDataFromApi()
        }
      }
    },
    async DeleteVergelijkingspunt () {
      var blobs = await this.BlobMixin_GetFiles(this.selectedItem.idVergelijkingspunt, this.vergelijkingsPuntType)
      blobs.forEach(blob => {
        this.BlobMixin_DeleteBlobById(blob.idBlob)
      })
      const response = await vergelijkingspuntService.Delete(this.selectedItem.idVergelijkingspunt)
      if (response && response.data) {
        this.editdialog = false
        this.deletedialog = false
        this.getDataFromApi()
      }
    },
    FormatSelectedItem () {
      this.formattedSelectedItem = this.CommonMixin_Clone(this.selectedItem)
      this.formattedSelectedItem.datumVerkoop = (this.selectedItem.jaarVerkoop && this.selectedItem.maandVerkoop) ? moment(new Date(this.selectedItem.jaarVerkoop, this.selectedItem.maandVerkoop)) : null
    }
  }
}
</script>
